module.exports = __webpack_public_path__ + "static/media/Leader Scoreboard SWORD.ff5a213b.svg";